import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";
import RollingBox from "components/other/RollingBox";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import Dropdown from "components/forms/Dropdown";
import DropdownSelection from "components/forms/DropdownSelection";
import Tip from "components/other/Tip";
import SelectionItem from "components/forms/SelectionItem";
import InputWithLabel from "components/forms/InputWithLabel";
import InputText from "components/forms/InputText";
import Backdrop from "components/other/Backdrop";
import ModalWindow from "components/other/ModalWindow";
import MessageWindow from "components/other/MessageWindow";

import pencilIcon from "assets/img/icons/pencil-icon.svg";
import pencilWhiteIcon from "assets/img/icons/pencil-icon-white.svg";
import copyIcon from "assets/img/icons/copy-icon.svg";
import copyWhiteIcon from "assets/img/icons/copy-icon-white.svg";
import binIcon from "assets/img/icons/bin-icon.svg";
import binWhiteIcon from "assets/img/icons/bin-icon-white.svg";
import adPlanIcon from "assets/img/icons/icons8-web-advertising.svg";
import checkIcon from "assets/img/icons/icons8-check.svg";
import checkWhiteIcon from "assets/img/icons/icons8-check-white.svg";

const PageListPage = styled.div`
  position: relative;

  display: flex;
`;

const PageBox = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;
  max-width: 750px;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  transition: 0.2s;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const PageBoxTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  @media (max-width: ${globalConstants.switchMobile}) {
    gap: ${css.VERTICAL_BOX_MARGIN};
  }
`;

const BoxHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BoxHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

const LimitBadge = styled.div`
  height: 20px;
  padding: 0 14px 0px;

  border-radius: 10px;
  background: #ff9500;

  display: flex;
  align-items: center;
  gap: 3px;

  &:hover {
    cursor: help;
  }
`;

const LimitBadgeText = styled.div`
  font-size: 13px;
  color: #fff;
  white-space: nowrap;
`;

const LimitBadgeIcon = styled.div`
  width: 12px;
  min-width: 12px;
  padding-bottom: 1px;
`;

const PageName = styled.div`
  padding-top: 4px;
  padding-bottom: 7px;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
  overflow-wrap: anywhere;

  @media (max-width: ${globalConstants.switchMobile}) {
    padding-top: 0px;
  }
`;

const HeaderControls = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const ControlButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ControlsLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PageBoxes = styled.div`
  display: flex;
  gap: ${css.VERTICAL_BOX_MARGIN};
  align-self: flex-start;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const PagePreview = styled.div`
  width: calc(1440px * 0.2);
  height: calc(900px * 0.2);
  display: inline-block;
  overflow: hidden;
  position: relative;

  border-radius: ${css.BOX_RADIUS_SECONDARY};
`;

const PageThumbnail = styled.div`
  width: 1440px;
  height: 900px;
  position: relative;
  -ms-zoom: 0.2;
  -moz-transform: scale(0.2);
  -moz-transform-origin: 0 0;
  -o-transform: scale(0.2);
  -o-transform-origin: 0 0;
  -webkit-transform: scale(0.2);
  -webkit-transform-origin: 0 0;

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

const ThumbnailIframe = styled.iframe`
  width: 1440px;
  height: 900px;
`;

const PageSettings = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const SettinsgItemTitle = styled.div`
  width: 100%;
  padding-left: 3px;

  font-size: 16px;
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};

  display: flex;
  align-items: center;
  gap: 8px;
`;

const SettingsItemLine = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};

  @media (max-width: ${globalConstants.switchMobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SettingsItemValue = styled.div`
  padding: 4px 0 4px 3px;
`;

const SettingsItemButtonWrap = styled.div``;

const ListHidingBox = styled.div`
  margin-top: 10px;
  padding-bottom: 15px;
  /* min-height: 165px; */

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const DropdownWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 290px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const ListSelectionItem = styled.div`
  font-family: "Arial", sans-serif;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const MailingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

const Text = styled.div`
  line-height: 130%;
`;

const ManageLists = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const LinkFormHidingBox = styled.div`
  margin-top: 10px;
  padding-bottom: 15px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const Warning = styled.div`
  margin-top: 7px;

  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

const ModalWrap = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
`;

const DisabledModalWrap = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  max-width: 550px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 2000;
`;

const DisabledWindowContent = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const DisabledHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const DisabledHeadingIcon = styled.div`
  width: 36px;
  min-width: 36px;
  height: 36px;
`;

const DisabledHeadingText = styled.div`
  font-size: 24px;
`;

const DisabledText = styled.div`
  text-align: center;
  line-height: 130%;
`;

const UrlInputWrap = styled.div`
  position: relative;
  max-width: 400px;
`;

const CopyIconBox = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;

  transform: translateY(-50%);
`;

const ControlsComponent = ({
  pageCode,
  onEditClick,
  onDeleteClick,
  loadingDelete,
  onDuplicateClick,
}) => {
  return (
    <ControlButtons>
      <ButtonRoundIcon
        icon={pencilIcon}
        hoverIcon={pencilWhiteIcon}
        background={css.BRAND_YELLOW}
        hoverBackground={css.BRAND_GREEN}
        onClick={() => onEditClick(pageCode)}
        buttonSize="34px"
        iconSize="15px"
      />
      <ButtonRoundIcon
        icon={copyIcon}
        hoverIcon={copyWhiteIcon}
        background={css.BRAND_YELLOW}
        hoverBackground={css.BRAND_GREEN}
        onClick={() => onDuplicateClick(pageCode)}
        buttonSize="34px"
        iconSize="15px"
      />
      <ButtonRoundIcon
        icon={binIcon}
        hoverIcon={binWhiteIcon}
        background={css.BRAND_YELLOW}
        hoverBackground={css.NEGATIVE_RED}
        onClick={() => onDeleteClick(pageCode)}
        buttonSize="34px"
        iconSize="15px"
        disabled={loadingDelete}
      />
    </ControlButtons>
  );
};

export default ({
  id,
  code,
  name,
  list,
  redirectLink,
  pageLists,
  onEditClick,
  changeListToggle,
  listFormOpened,
  selectedList,
  onDeleteClick,
  loadingDelete,
  onDuplicateClick,
  listSelectionOpened,
  onListSelect,
  changeList,
  toggleListSelection,
  changeListLoading,
  changeError,
  onCloseErrorModal,
  changeLinkToggle,
  linkFormOpened,
  redirectLinkInput,
  handleLinkInputChange,
  warnings,
  changeLink,
  changeLinkLoading,
  disabledModal,
  onCloseDisabledModal,
}) => {
  const listDropdownRef = useRef();
  const listSelectionRef = useRef();
  const listFormButtonRef = useRef();
  const linkDropdownRef = useRef();
  const linkSelectionRef = useRef();
  const linkFormButtonRef = useRef();
  const navigate = useNavigate();

  const [copied, setCopied] = useState(false);

  const mobileScreen = useMediaQuery({
    query: `(max-width: ${globalConstants.switchMobile})`,
  });

  function useListSelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !listDropdownRef.current.contains(event.target) &&
          !listFormButtonRef.current.contains(event.target)
        ) {
          toggleListSelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useListSelectionOutsideClick(listSelectionRef);

  let listOptionsList = [];

  Object.keys(pageLists).forEach((list) => {
    listOptionsList.push(
      <SelectionItem
        onClick={() => onListSelect(pageLists[list])}
        key={pageLists[list].id}
      >
        <ListSelectionItem>{pageLists[list].name}</ListSelectionItem>
      </SelectionItem>
    );
  });

  const linkCopied = () => {
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <PageListPage>
      <PageBox key={id}>
        <PageBoxTop>
          <BoxHeadWrapper>
            <BoxHeader>
              <PageName>{name}</PageName>
              <HeaderControls>
                {!mobileScreen && (
                  <ControlsComponent
                    pageCode={code}
                    onEditClick={onEditClick}
                    onDeleteClick={onDeleteClick}
                    loadingDelete={loadingDelete}
                    onDuplicateClick={onDuplicateClick}
                  />
                )}
              </HeaderControls>
            </BoxHeader>
          </BoxHeadWrapper>
          <PagePreview>
            <PageThumbnail>
              <ThumbnailIframe
                src={`http://localhost:5173/?code=${code}`}
                frameborder="0"
              ></ThumbnailIframe>
            </PageThumbnail>
          </PagePreview>
          <PageBoxes></PageBoxes>
        </PageBoxTop>

        <InputWithLabel
          label="Landing Page URL"
          tip="The web address of your landing page. Copy and share this address with your audience."
          tipId="pageUrl"
        >
          <UrlInputWrap>
            <InputText
              type="text"
              value={`http://localhost:5173/?code=${code}`}
              readOnly={true}
              righticonspace={true}
            />
            <CopyIconBox>
              <CopyToClipboard
                text={`http://localhost:5173/?code=${code}`}
                onCopy={linkCopied}
              >
                <ButtonRoundIcon
                  icon={copied ? checkIcon : copyIcon}
                  hoverIcon={copied ? checkWhiteIcon : copyWhiteIcon}
                  background={css.BRAND_YELLOW}
                  hoverBackground={css.BRAND_GREEN}
                  buttonSize="24px"
                  iconSize="10px"
                />
              </CopyToClipboard>
            </CopyIconBox>
          </UrlInputWrap>
        </InputWithLabel>

        <PageSettings>
          <RollingBox>
            <MailingList>
              <SettinsgItemTitle>
                Mailing List
                <Tip
                  tipId="mailingList"
                  tip="The name of the list where collected leads will be saved."
                />
              </SettinsgItemTitle>
              <SettingsItemLine>
                <SettingsItemValue>{list.name}</SettingsItemValue>
                <SettingsItemButtonWrap ref={listFormButtonRef}>
                  <ButtonPrimarySmall onClick={changeListToggle}>
                    {listFormOpened ? "Close" : "Change List"}
                  </ButtonPrimarySmall>
                </SettingsItemButtonWrap>
              </SettingsItemLine>
              {listFormOpened && (
                <ListHidingBox>
                  <Text>
                    Select the mailing list where leads collected from this page
                    will be saved.
                  </Text>
                  <DropdownWrap>
                    <Dropdown
                      onClick={toggleListSelection}
                      dropdownRef={listDropdownRef}
                    >
                      <ListSelectionItem>{selectedList.name}</ListSelectionItem>
                    </Dropdown>
                    {listSelectionOpened && (
                      <DropdownSelection
                        width="290px"
                        top="48px"
                        selectionRef={listSelectionRef}
                        maxHeight="220px"
                      >
                        {listOptionsList}
                      </DropdownSelection>
                    )}
                    <ButtonWrap>
                      <ButtonPrimary
                        onClick={changeList}
                        disabled={changeListLoading}
                      >
                        Save
                      </ButtonPrimary>
                    </ButtonWrap>
                  </DropdownWrap>
                  <ManageLists>
                    <Text>
                      You can create a new mailing list by clicking the Manage
                      Lists button.
                    </Text>
                    <ButtonWrap>
                      <ButtonPrimarySmall>Manage Lists</ButtonPrimarySmall>
                    </ButtonWrap>
                  </ManageLists>
                </ListHidingBox>
              )}
            </MailingList>
          </RollingBox>
          <RollingBox>
            <MailingList>
              <SettinsgItemTitle>
                Redirect Link
                <Tip
                  tipId="redirectUrl"
                  tip={`The web address to which visitors of your landing page are redirected after they fill out and submit the contact form.<br><br>
                  Enter a valid URL that your leads will visit after submitting the form.`}
                />
              </SettinsgItemTitle>
              <SettingsItemLine>
                <SettingsItemValue>{redirectLink}</SettingsItemValue>
                <SettingsItemButtonWrap ref={linkFormButtonRef}>
                  <ButtonPrimarySmall onClick={changeLinkToggle}>
                    {linkFormOpened ? "Close" : "Change Link"}
                  </ButtonPrimarySmall>
                </SettingsItemButtonWrap>
              </SettingsItemLine>
              {linkFormOpened && (
                <LinkFormHidingBox>
                  <InputWithLabel label="Change Redirect URL">
                    <InputText
                      type="text"
                      name="redirectUrl"
                      value={redirectLinkInput}
                      placeholder="Enter your website URL link"
                      onChange={handleLinkInputChange}
                      maxLength={500}
                      warning={warnings.includes("redirectUrl")}
                    />
                    {warnings.includes("redirectUrl") && (
                      <Warning>
                        The entered URL is invalid. The address should start
                        with https://
                      </Warning>
                    )}
                  </InputWithLabel>

                  <ButtonWrap>
                    <ButtonPrimary
                      onClick={changeLink}
                      disabled={changeLinkLoading}
                    >
                      Save
                    </ButtonPrimary>
                  </ButtonWrap>
                </LinkFormHidingBox>
              )}
            </MailingList>
          </RollingBox>
        </PageSettings>
        {mobileScreen && (
          <ControlsLine>
            <ControlsComponent
              pageId={id}
              onEditClick={onEditClick}
              onDeleteClick={onDeleteClick}
              loadingDelete={loadingDelete}
              onDuplicateClick={onDuplicateClick}
            />
          </ControlsLine>
        )}
      </PageBox>
      {disabledModal && (
        <ModalWrap>
          <Backdrop
            onClick={onCloseDisabledModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <DisabledModalWrap>
            <ModalWindow
              modal="changeError"
              handleModalClose={onCloseDisabledModal}
              fullScreenHeight={true}
            >
              <DisabledWindowContent>
                <DisabledHeading>
                  <DisabledHeadingIcon>
                    <img
                      src={adPlanIcon}
                      style={{ width: "100%", paddingTop: "1px" }}
                    />
                  </DisabledHeadingIcon>
                  <DisabledHeadingText>
                    Subscribe to Ad Plan
                  </DisabledHeadingText>
                </DisabledHeading>
                <DisabledText>
                  By default, your landing pages redirect visitors who submit
                  the form to the Scalelup website using your referral link. If
                  you want to use a different link and redirect your leads
                  elsewhere, you need to have an active Scalelup Ad Plan.
                </DisabledText>
                <ButtonWrap>
                  <ButtonPrimary
                    onClick={() => navigate("/advertising-plans")}
                    disabled={changeLinkLoading}
                  >
                    Get Ad Plan
                  </ButtonPrimary>
                </ButtonWrap>
              </DisabledWindowContent>
            </ModalWindow>
          </DisabledModalWrap>
        </ModalWrap>
      )}
      {changeError && (
        <ModalWrap>
          <Backdrop
            onClick={onCloseErrorModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <MessageWindow handleModalClose={onCloseErrorModal} title="Error">
            {changeError}
          </MessageWindow>
        </ModalWrap>
      )}
    </PageListPage>
  );
};
